import React from 'react';
import {Link,Box,Flex} from 'rebass';

export default function ListSims(props) {
    
    const similars = props.similars
    
    return (
        <div>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>1. <Link href="#" onClick={e => {props.setQuery(similars[1]); props.setRedirect(true)}} fontWeight='bold'>{similars[1]}</Link>{" ("+Math.round(similars[0]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>11. <Link href="#" onClick={e => {props.setQuery(similars[21]); props.setRedirect(true)}} fontWeight='bold'>{similars[21]}</Link>{" ("+Math.round(similars[20]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>2. <Link href="#" onClick={e => {props.setQuery(similars[3]); props.setRedirect(true)}} fontWeight='bold'>{similars[3]}</Link>{" ("+Math.round(similars[2]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>12. <Link href="#" onClick={e => {props.setQuery(similars[23]); props.setRedirect(true)}} fontWeight='bold'>{similars[23]}</Link>{" ("+Math.round(similars[22]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>3. <Link href="#" onClick={e => {props.setQuery(similars[5]); props.setRedirect(true)}} fontWeight='bold'>{similars[5]}</Link>{" ("+Math.round(similars[4]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>13. <Link href="#" onClick={e => {props.setQuery(similars[25]); props.setRedirect(true)}} fontWeight='bold'>{similars[25]}</Link>{" ("+Math.round(similars[24]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>4. <Link href="#" onClick={e => {props.setQuery(similars[7]); props.setRedirect(true)}} fontWeight='bold'>{similars[7]}</Link>{" ("+Math.round(similars[6]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>14. <Link href="#" onClick={e => {props.setQuery(similars[27]); props.setRedirect(true)}} fontWeight='bold'>{similars[27]}</Link>{" ("+Math.round(similars[26]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>5. <Link href="#" onClick={e => {props.setQuery(similars[9]); props.setRedirect(true)}} fontWeight='bold'>{similars[9]}</Link>{" ("+Math.round(similars[8]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>15. <Link href="#" onClick={e => {props.setQuery(similars[29]); props.setRedirect(true)}} fontWeight='bold'>{similars[29]}</Link>{" ("+Math.round(similars[28]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>6. <Link href="#" onClick={e => {props.setQuery(similars[11]); props.setRedirect(true)}} fontWeight='bold'>{similars[11]}</Link>{" ("+Math.round(similars[10]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>16. <Link href="#" onClick={e => {props.setQuery(similars[31]); props.setRedirect(true)}} fontWeight='bold'>{similars[31]}</Link>{" ("+Math.round(similars[30]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>7. <Link href="#" onClick={e => {props.setQuery(similars[13]); props.setRedirect(true)}} fontWeight='bold'>{similars[13]}</Link>{" ("+Math.round(similars[12]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>17. <Link href="#" onClick={e => {props.setQuery(similars[33]); props.setRedirect(true)}} fontWeight='bold'>{similars[33]}</Link>{" ("+Math.round(similars[32]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>8. <Link href="#" onClick={e => {props.setQuery(similars[15]); props.setRedirect(true)}} fontWeight='bold'>{similars[15]}</Link>{" ("+Math.round(similars[14]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>18. <Link href="#" onClick={e => {props.setQuery(similars[35]); props.setRedirect(true)}} fontWeight='bold'>{similars[35]}</Link>{" ("+Math.round(similars[34]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>9. <Link href="#" onClick={e => {props.setQuery(similars[17]); props.setRedirect(true)}} fontWeight='bold'>{similars[17]}</Link>{" ("+Math.round(similars[16]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'  
                color='black'
                bg='F1F1F2'>
                <p>19. <Link href="#" onClick={e => {props.setQuery(similars[37]); props.setRedirect(true)}} fontWeight='bold'>{similars[37]}</Link>{" ("+Math.round(similars[36]*100)+"% match)"}</p>
            </Box>
            </Flex>
            <Flex height='50px' mb="20px">
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'
                color='black'
                bg='F1F1F2'>
                <p>10. <Link href="#" onClick={e => {props.setQuery(similars[19]); props.setRedirect(true)}} fontWeight='bold'>{similars[19]}</Link>{" ("+Math.round(similars[18]*100)+"% match)"}</p>
            </Box>
            <Box
                width={1/2}
                textAlign='left'
                pl={4}
                fontFamily='arial black'
                fontSize='3'
                color='black'
                bg='F1F1F2'>
                <p>20. <Link href="#" onClick={e => {props.setQuery(similars[39]); props.setRedirect(true)}} fontWeight='bold'>{similars[39]}</Link>{" ("+Math.round(similars[38]*100)+"% match)"}</p>
            </Box>
            </Flex>
        </div>
    );
}